module.exports = __webpack_public_path__ + "img/hzico_12.badd10d4.jpg";